import { Injectable } from "@angular/core";
import { MetadatiFascicoloDTO } from "@app/shared/dto/metadati-fascicoloDTO";
import { MetadatiFascicoloVO } from "@app/shared/vo/metadati-fascicoloVO";
import { MapperClassifica } from "../mapper-classifica";
import { MapperInterface } from "../mapper-inteface";
import { MapperTipoIstanzaFascicolo } from "../mapper-tipo-istanza-fascicolo";
import { MapperMetaDatiProtocolloGescor } from "./mapper-metadati-protocollo-gescor";

@Injectable({
  providedIn: "root",
})
export class MapperMetaDatiFascicolo
  implements MapperInterface<MetadatiFascicoloDTO, MetadatiFascicoloVO> {
  constructor(
    private mapperClassifica: MapperClassifica,
    private mapperTipologia: MapperTipoIstanzaFascicolo
  ) {}
  convertVoToDto(t: MetadatiFascicoloVO): MetadatiFascicoloDTO {
    const metadatiFascicoloDTO = new MetadatiFascicoloDTO();

    metadatiFascicoloDTO.idFascicolo = t.idFascicolo;
    metadatiFascicoloDTO.segnaturaArchivistica = t.segnaturaArchivistica;

/*     metadatiFascicoloDTO.oggetto = t.oggetto;
    metadatiFascicoloDTO.classifica = this.mapperClassifica.convertDtoToVo(
      t.classifica
    );
    metadatiFascicoloDTO.tipologia = this.mapperTipologia.convertDtoToVo(
      t.tipologia
    ) ;*/
    return metadatiFascicoloDTO || new MetadatiFascicoloDTO();
  }
  convertDtoToVo(t: MetadatiFascicoloDTO): MetadatiFascicoloVO {
    const metadatiFascicoloVO = new MetadatiFascicoloVO();
    if (t !== null) {

      metadatiFascicoloVO.idFascicolo = t.idFascicolo;
      metadatiFascicoloVO.segnaturaArchivistica = t.segnaturaArchivistica;

  /*     metadatiFascicoloVO.oggetto = t.oggetto;
      metadatiFascicoloVO.classifica = this.mapperClassifica.convertDtoToVo(
        t.classifica
      );
      metadatiFascicoloVO.tipologia = this.mapperTipologia.convertDtoToVo(
        t.tipologia
      ); */
    }

    return metadatiFascicoloVO || new MetadatiFascicoloVO();
  }
  convertListVoToDto(e: MetadatiFascicoloVO[]): MetadatiFascicoloDTO[] {
    const metadatiFascicoloDTOList = new Array<MetadatiFascicoloDTO>();
    e.forEach((metadatiFascicoloVO) => {
      metadatiFascicoloDTOList.push(this.convertVoToDto(metadatiFascicoloVO));
    });
    return metadatiFascicoloDTOList || new Array<MetadatiFascicoloDTO>();
  }
  convertListDtoToVo(t: MetadatiFascicoloDTO[]): MetadatiFascicoloVO[] {
    const metadatiFascicoloVOList = new Array<MetadatiFascicoloVO>();
    if (t != null) {
      t.forEach((metadatiFascicoloDTO) => {
        metadatiFascicoloVOList.push(this.convertDtoToVo(metadatiFascicoloDTO));
      });
    }
    return metadatiFascicoloVOList;
  }
}
